import { render, staticRenderFns } from "./SliderForm.vue?vue&type=template&id=15cbf6c0&"
import script from "./SliderForm.vue?vue&type=script&lang=js&"
export * from "./SliderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports